module.exports = __webpack_public_path__ + "static/adobe-stock-278687682-3c47a8d7e356ef5317954b6291caae5a.jpg";